import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';

import EmptySneaker from '../../images/emptysneakers2.png';

import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { getCacheImage } from '../../config'

class PageSearchResult extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstRender: false
    }

  }

  checkingSearchResult () {
    const { dataProduct } = this.props;
    if (dataProduct.searchKeyword !== '' && dataProduct.errorMessageSearch === "Sneaker ditemukan") {
			return (
        <Row>
				{
					this.props.dataProduct.searchResult.map((a, index) => (
					<Col key={index} className="wrapper-search-result" sm="6" xs="6" md="4">
							<Link to={`/sneakers/${ a.id }/${ a.slug }`} onClick={(e)=>{
                this.props.history.push(`/sneakers/${ a.id }/${ a.slug }`);
                // window.location.reload();
                // this.props.closeModalSearch()
              }}
              className="item-search">
								<div className="image-result">
									{
                    a.product_variant_images.length === 0 ?
                    <KickImage src={EmptySneaker} alt="Northern Lights" width="100%" height="100%" />
                    :
                    <KickImage src={`${getCacheImage(a.product_variant_images[0].signed_url || a.product_variant_images[0].URL)}`} alt="Northern Lights" width="100%" height="100%" />
                  }
								</div>
								{/* <p className="popular-search display_name">{ a.display_name }</p> */}
							</Link>
					</Col>
				))
				}
				</Row>
			)
		} else if (dataProduct.searchResult.length === 0) {
      if (dataProduct.errorMessageSearch === '') {
        return (
          <Container className="page-container" style={{minHeight:500, display:'flex',alignItems:'center',flexDirection:'row'}}>
            <div style={{flex:1 }}>
                <div style={{width:300,margin:"15px auto"}}>
                    <div className="progress-load"
                      style={{ display: 'flex', justifyContent: "center",alignItems: "center" }}>
                      <ReactLoading type={'spinningBubbles'} color={'#fff'}/>
                    </div>
                </div>
            </div>
          </Container>
        )
      }
			return (
        <Container className="page-container" style={{minHeight:500, display:'flex',alignItems:'center',flexDirection:'row'}}>
          <div style={{flex:1}}>
              <div className="error-search-message" style={{width:300,margin:"15px auto"}}>
                  <h1 className="text-center">404 Not Found</h1>
                  <h5 className="text-center">Sneaker tidak ditemukan</h5>
              </div>
          </div>
        </Container>
			)
		}
  }

  render () {
    return (
      <div style={{ marginTop: 20 }}>
        {
          this.checkingSearchResult()
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataProduct: state.dataProduct
})

export default connect(mapStateToProps, null)(PageSearchResult);
